export default "__VITE_ASSET__DpnnhVSP__"